<template>
  <!-- article dialog -->
  <v-dialog
    v-model="isOpen"
    width="750px"
    persistent
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card tile>
      <v-toolbar flat dark color="rgb(51, 97, 137)">
        <v-toolbar-title>
          <v-icon left>mdi-format-float-left</v-icon
          >{{
            this.$vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertArticle.addEditArticle'
            )
          }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn icon dark @click="checkToSave" v-on="on">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
          <span class="subtitle-1">{{
            this.$vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertArticle.close'
            )
          }}</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text>
        <v-form ref="form" v-model="valid" v-on:submit.prevent="validate">
          <!-- <v-row justify="center"> -->
          <!-- <v-col cols="12" lg="12" md="12" sm="12" xs="12"> -->
          <v-row>
            <v-col>
              <p class="title">
                {{
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertArticle.articleName'
                  )
                }}
                <span class="red--text">*</span>
              </p>
              <v-text-field
                outlined
                :rules="nameRules"
                clearable
                class="textField"
                :placeholder="
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertArticle.articleName'
                  )
                "
                v-model="title"
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <p class="title">
                {{
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertArticle.detail'
                  )
                }}
                <span class="red--text">*</span>
              </p>
              <quill-editor
                class="editor"
                v-model="description"
                ref="description"
                :value="description"
                :options="editorOption"
              />
              <div v-if="validateQuill">
                {{
                  this.$vuetify.lang.t(
                    '$vuetify.courseManagement.lectureStep.insertArticle.pleaseFillDetail'
                  )
                }}
              </div>
            </v-col>
          </v-row>
          <!-- </v-col> -->
          <!-- </v-row> -->
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          elevation="0"
          class="px-9 ma-2 subtitle-2 button-secondary font-weight-light text-capitalize"
          outlined
          @click="checkToSave"
          >{{
            this.$vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertYoutube.cancel'
            )
          }}</v-btn
        >
        <v-btn
          elevation="0"
          class="px-10 ma-2 subtitle-2 text-capitalize font-weight-light button-primary"
          @click="validate"
          :disabled="!valid || description == ''"
          >{{
            this.$vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertYoutube.save'
            )
          }}</v-btn
        >
      </v-card-actions>
    </v-card>
    <v-dialog v-model="warnningToSaveDialog" max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.alertLeavePageTitle'
          )
        }}</v-card-title>
        <v-card-text>{{
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.alertLeavePageSubTitle'
          )
        }}</v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            elevation="0"
            class="mb-0 body-2 text-capitalize"
            color="white"
            @click="warnningToSaveDialog = false"
          >
            <p class="mb-0">
              {{
                this.$vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertYoutube.continue'
                )
              }}
            </p>
          </v-btn>

          <v-btn
            elevation="0"
            class="mb-0 body-2 text-primary text-capitalize"
            color="white"
            @click="closeLectureDialog"
          >
            <p class="mb-0">
              {{
                this.$vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.exit'
                )
              }}
            </p>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>
<script>
import {
  insertLecture,
  updateLecture,
  insertBlog,
  updateBlog,
  getDetailBlog,
} from '@/service/course/course.js';
export default {
  props: {
    isLectureOpen: {
      type: Boolean,
    },
    isOpen: {
      type: Boolean,
    },
    lectureId: {
      type: String,
    },
    lectures: {
      type: Array,
    },
    sectionId: {
      type: String,
    },
    reload: {
      type: Function,
    },
    closeDialog: {
      type: Function,
    },
    closeLectureDialog: {
      type: Function,
    },
  },
  components: {},
  data() {
    return {
      valid: true,

      title: '',
      description: '',
      oldBlog: {},

      editorOption: {},
      maxWidth: '40%',
      nameRules: [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertArticle.pleaseFillName'
          ),
      ],
      validateQuill: false,

      //check to save
      oldValue: [],
      warnningToSaveDialog: false,
    };
  },
  // computed: {
  //   validateQuill
  // },
  watch: {
    // whenever question changes, this function will run
    // lectureId: async function(newValue, oldValue) {
    //   console.log(newValue, oldValue, this.lectures);
    //   let filterLecture = this.lectures.filter(
    //     lecture => lecture._id === newValue
    //   )[0];
    //   console.log(filterLecture);
    //   this.title = filterLecture.blogs[0].title;
    //   this.description = filterLecture.blogs[0].text;
    //   this.oldBlog = filterLecture.blogs[0];
    // },
    isOpen: async function (newValue) {
      if (newValue) {
        if (this.lectureId) {
          let filterLecture = this.lectures.filter(
            (lecture) => lecture._id === this.lectureId
          )[0];
          this.title = filterLecture.blogs[0].title;
          let resultDescription = await getDetailBlog({
            idblog: filterLecture.blogs[0]._id,
          });
          this.description = resultDescription.text;
          this.oldBlog = filterLecture.blogs[0];
          this.oldValue = {
            title: filterLecture.blogs[0].title,
            text: resultDescription.text,
          };
        } else {
          this.title = '';
          this.description = '';
          this.oldBlog = null;
          this.oldValue = [];
          if (this.$refs.form) {
            this.$refs.form.resetValidation();
          }
        }
      }
    },
  },
  methods: {
    // onEditorChange({ quill, html, text }) {
    //   this.content = html;
    // },
    async validate() {
      if (this.$refs.form.validate() && this.description !== '') {
        if (!this.lectureId) {
          let blog = await insertBlog({
            title: this.title,
            text: this.description,
          });

          await insertLecture({
            id: this.sectionId,
            title: this.title,
            description: '',
            blogs: [blog._id],
            type: 'BLOG',
          });

          // let newLectures = this.lectures.map(lecture => lecture._id);
          // newLectures.push(result._id);

          this.reload();
          this.closeDialog();
        } else {
          let currentLecture = this.lectures.filter(
            (lecture) => lecture._id === this.lectureId
          )[0];

          await updateBlog({
            ...this.oldBlog,
            id: this.oldBlog._id,
            title: this.title,
            text: this.description,
          });

          await updateLecture({
            ...currentLecture,
            id: this.lectureId,
            title: this.title,
            type: 'BLOG',
          });
        }
        this.closeLectureDialog();
      } else {
        this.validateQuill = true;
        console.log('not pass');
      }
    },
    checkToSave() {
      if (this.lectureId) {
        this.title !== this.oldValue.title ||
        this.description !== this.oldValue.text
          ? (this.warnningToSaveDialog = true)
          : this.closeLectureDialog();
      } else {
        this.title !== '' || this.description !== ''
          ? (this.warnningToSaveDialog = true)
          : this.closeLectureDialog();
      }
    },
  },
  beforeMount() {
    if (window.screen.width < 600) {
      this.maxWidth = '90%';
    } else if (window.screen.width > 600 && window.screen.width < 960) {
      this.maxWidth = '90%';
    } else if (window.screen.width > 960 && window.screen.width < 1264) {
      this.maxWidth = '90%';
    } else if (window.screen.width > 1264 && window.screen.width < 1904) {
      this.maxWidth = '40%';
    } else {
      this.maxWidth = '40%';
    }
  },
};
</script>
<style scoped>
.button-primary {
  background-color: rgb(66, 154, 216) !important;
  color: white;
}
.dialogStyle {
  height: 1000px;
}
.rowContentmange {
  border-style: solid;
  border-radius: 15px;
  border-color: rgb(195, 195, 195);
  border-right-width: thin;
  border-top-width: thin;
  border-left-width: thin;
  border-bottom-width: thin;
  min-height: 700px;
  /* min-height: auto; */
}
.textInbutton.v-btn__content {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
}
.textField {
  width: 100%;
}
.labelAttach.v-label.theme--light {
  color: rgba(0, 0, 0, 0.6);
  margin-left: 30px;
}
p {
  margin: 0 0 5px;
}
.v-card__text.dialogStyle {
  height: 1000px;
  width: 70%;
  margin: 0 auto;
}
.manageButton {
  justify-content: flex-end;
}
.textAreaDetail {
  border-radius: 15px;
}
.editor {
  height: 340px;
  margin-bottom: 70px;
}
.text-primary {
  color: rgb(66, 154, 216) !important;
}
@media only screen and (max-width: 1024px) {
  .v-card__text.dialogStyle {
    width: 100%;
    margin: 0 auto;
  }
}
</style>
